.shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 17rem;
  align-items: start;
  max-width: 92rem;
  min-height: calc(100dvh - 4rem);
  margin-inline: auto;
}

.toc {
  grid-column: 2;
  grid-row: 1;
  position: sticky;
  top: 5.5rem;
  max-height: calc(100dvh - 7rem);
  margin-block: 1.5rem;
  margin-inline: 0 1rem;
}

.lastUpdated {
  width: min(100%, 58rem);
  margin: 2rem auto 0;
  color: var(--color-muted);
  font-size: 0.875rem;
}

@media (max-width: 1199px) {
  .shell {
    grid-template-columns: minmax(0, 1fr);
  }

  /* Two classes: the table of contents' own stylesheet sets its display. */
  .shell .toc {
    display: none;
  }
}
